module.exports = __webpack_public_path__ + "img/abt.90a0e76a.svg";